import React from 'react';
import { GreyDot } from './GreyDot';
import TimelineItem from 'antd/lib/timeline/TimelineItem';
import { Row, Col, Tooltip } from 'antd';
import { formatDisplayTime, formatDurationInMillis } from '../utils/timeUtils';
import { UILegacyEvent } from '../../../types/flyingPage';

interface LegacyEventTimelineItemProps {
  flightActive: boolean;
  legacyEvent: UILegacyEvent;
  dateFormat: string;
  timeFormat: string;
  timezone: string;
}

export const LegacyEventTimelineItem: React.FC<LegacyEventTimelineItemProps> = ({
  flightActive,
  legacyEvent,
  dateFormat,
  timeFormat,
  timezone
}) => {
  const dateTimeFormat = `${dateFormat} ${timeFormat}`;
  const formattedDuration = legacyEvent.durationMillis
    ? formatDurationInMillis(legacyEvent.durationMillis)
    : '';

  return (
    <TimelineItem
      dot={!flightActive ? <GreyDot /> : undefined}
      color={flightActive ? 'grey' : undefined}
    >
      <Row style={{ marginLeft: '5px' }}>
        <Col span={6} style={{ textAlign: 'left' }}>
          <span>
            {formatDisplayTime(legacyEvent.eventTime, timezone, dateTimeFormat, timeFormat)}
          </span>
        </Col>
        <Col span={13} style={{ textAlign: 'left' }}>
          <span>{legacyEvent.eventName}</span>
        </Col>
        <Col span={legacyEvent.durationMillis ? 5 : 0} style={{ textAlign: 'end' }}>
          {legacyEvent.durationMillis ? (
            legacyEvent.eventDescription ? (
              <Tooltip title={legacyEvent.eventDescription} placement="right">
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    gap: '4px'
                  }}
                >
                  <div style={{ minWidth: '30px', textAlign: 'right' }}>
                    {formattedDuration.split(' ')[0]}
                  </div>
                  <div style={{ minWidth: '35px', textAlign: 'left' }}>
                    <span style={{ color: '#8C8C8C' }}>{formattedDuration.split(' ')[1]}</span>
                  </div>
                </div>
              </Tooltip>
            ) : (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  gap: '4px'
                }}
              >
                <div style={{ minWidth: '30px', textAlign: 'right' }}>
                  {formattedDuration.split(' ')[0]}
                </div>
                <div style={{ minWidth: '35px', textAlign: 'left' }}>
                  <span style={{ color: '#8C8C8C' }}>{formattedDuration.split(' ')[1]}</span>
                </div>
              </div>
            )
          ) : (
            ''
          )}
        </Col>
      </Row>
    </TimelineItem>
  );
};
